import { useService } from 'solid-services'
import { useFilters } from '../state/filter'
import { ValuesCombobox } from './ValuesCombobox'

export default function SymbolSearchCombobox() {
  const { setSymbols, filters } = useService(useFilters)()

  return (
    <ValuesCombobox
      column="symbol"
      label="Symbols"
      placeholder="Search symbols..."
      selected={filters().symbols}
      onChange={setSymbols}
    />
  )
}
